<template>
    <div>
      <div class="container"> 	
        <!-- projects -->
        <div class="  wthree animate__animated  animate__backInLeft nimate__backInDown row"  style="width: 100%; ">     
          <h2 class="agileits-title w3title1">项目</h2>
          <!-- <p class="top-p animate__shakeY">重点在研项目，主要项目名称.</p> -->
          <div class="w3ls-title"> 
        </div>
            <div class="row col-md-12 agileits-w3layouts animate__animated  nimate__backInDown"  >
 
              
              <el-table
              :data="projects"
              style="width: 100%"
              :row-class-name="tableRowClassName"
            >
                <el-table-column prop="projectName" label="名称" width="380" />
                <el-table-column prop="projectDescribe" label="描述" width="780" />
                <el-table-column prop="projectType" label="项目类型" width="180" />
                <!-- <el-table-column prop="indication" label="图片" width="180" /> -->
 
                <!-- <el-table-column prop="projectDescribe" label="项目描述" width="180" /> -->
            </el-table>
            </div>
        <div class="clearfix"> </div>
          </div>	 
          <section class="bar bg-gray no-mb padding-big text-md-center">
            <InnovationIndex></InnovationIndex>
          </section>
          <div class="clearfix"> </div>
        </div>
    <!-- //projects --> 
  </div>
</template>

<script>
import 'animate.css'
import * as  http from '@/request/http'
import { useRouter} from 'vue-router';
import { useStore } from 'vuex';
 

export default {
   components: {
    //   Pagination
    },
   data(){
    return {    
      currentPage: 1,
      pageSize: 10,
      totalItems: 1,  
      projects:[],
      projectsdata:{}
    }
   },
   methods: {
    handlePageChanged(newPage) {
       let  param = {
          newTitle: '',
          currentPage: this.currentPage,
          type:''
       }
        this.currentPage = newPage;
        http.projects.projectslist(param).then(res=>{
           console.log(res.data) 
           this.projectsdata = res.data,
           this.projects=res.data.rows
           this.currentPage =newPage;
           this.pageSize=10;
           this.totalItems=res.data.total
        })
      },
   },
   created(){
    this.handlePageChanged(1)
 
   },
   props: {
    user: Object
  },
  setup() {
    const router = useRouter();
    // 使用全局$store
    const store = useStore();
 
    function gotoDetail(item) {
      const state= item
      store.state.productStore.currentProduct=item
      router.push({ name: 'productDetail',state});
    }
    return {
      gotoDetail
    };
  }
}
</script>
